import { UntypedFormGroup } from "@angular/forms";
import { CellChangeArg, Cellstyle, HotCell } from "~app/common/components/hot-doc/hotdoc/cell";
import { IHotDocSettings } from "~app/common/components/hot-doc/hotdoc/doc";
import { Utils } from "~app/common/services/utils";
import { ILangdklass } from "../../../models/IProduktdefinition";
import { PrisCell } from "./prisCell";

export class StolpCell extends HotCell {
    langdklass: ILangdklass;
    dirty = false;
    constructor(
        langdklass: ILangdklass,
        form: UntypedFormGroup,
        protected value: number,
        flags?: Cellstyle,
        onHandle?: (newValue: CellChangeArg) => void) {

        super(flags, null, (newValue: CellChangeArg) => {
            if (newValue.newValue !== this.value) {
                onHandle(newValue);
                this.value = newValue.newValue;
                form.markAsDirty();
                this.dirty = true;
                newValue.complete();
            }
        });
        this.langdklass = langdklass;
        this.value = value;
    }

    setReadOnly(): void {
        /* eslint-disable no-bitwise */
        this.flags |= Cellstyle.Readonly;
    }

    validate(value: any): boolean {
        return Utils.isNumberLike(value, true);
    }

    override onDelete(settings: IHotDocSettings): void {
        if (this.isReadonly) {
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        const changeArg = this.changeArgumentFactory(0, () => { }, settings);
        this.onChange(changeArg);
    }

    protected applyStyle(td: HTMLTableCellElement, cellProperties: any) {
        super.applyStyle(td, cellProperties);

        td.classList.add(HotCell.hotNumber);

        if (this.dirty) {
            td.classList.add(HotCell.hotDirty);
        }
    }

    protected genHtml(): string {
        return PrisCell.format(this.value);
    }
}
